import { cva } from 'class-variance-authority';
import PropTypes from 'prop-types';
import { cn } from '../../lib/utils';

const badgeVariants = cva('inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-semibold', {
  variants: {
    variant: {
      default: 'border-transparent bg-primary text-primary-foreground',
      secondary: 'border-transparent bg-secondary text-secondary-foreground',
      outline: 'border-border bg-card text-foreground',
      success: 'border-emerald-200 bg-emerald-50 text-emerald-700',
      warning: 'border-amber-200 bg-amber-50 text-amber-700',
      due: 'border-orange-200 bg-orange-50 text-orange-700',
      destructive: 'border-red-200 bg-red-50 text-red-700',
      info: 'border-blue-200 bg-blue-50 text-blue-700',
    },
  },
  defaultVariants: { variant: 'default' },
});

export const Badge = ({ className, variant, ...props }) => (
  <span className={cn(badgeVariants({ variant }), className)} {...props} />
);

Badge.propTypes = { className: PropTypes.string, variant: PropTypes.string };
